var render = function render(){var _vm=this,_c=_vm._self._c;return _c('mars-view',{staticClass:"btn c-font-normal",class:{
    'shadow': _vm.shadow
},style:({
    display: _vm.auto
        ? 'inline-block'
        : '',
    padding: _vm.type === 'primary'
        ? (_vm.height - _vm.fontSize - 10)/2 + 'px 9px'
        : (_vm.height - _vm.fontSize - 10)/2 - 1 + 'px 8px',
    color: _vm.type === 'primary'
        ? '#fff'
        : _vm.primaryColor === '#555'
            ? '#000'
            : _vm.primaryColor,
    border: _vm.type !== 'primary' && !_vm.shadow
        ? '1px solid ' + _vm.primaryColor
        : '',
    backgroundColor: _vm.type === 'primary'
        ? _vm.primaryColor
        : _vm.touchActive
            ? 'rgba(0,0,0,.08)'
            : '#fff',
    opacity: _vm.touchActive && _vm.type === 'primary'
        ? 0.9
        : _vm.disabled
            ? 0.4
            : 1,
    background: _vm.background
        ? _vm.background
        : {},
    fontSize: _vm.fontSize + 'px',
    lineHeight: _vm.fontSize + 10 + 'px',
    borderRadius: _vm.borderRadius,
    fontWeight: _vm.fontWeight
}),nativeOn:{"touchstart":function($event){return _vm.handleTouchStart.apply(null, arguments)},"touchend":function($event){return _vm.handleTouchEnd.apply(null, arguments)}}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }